import { Component, EventEmitter, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from "@angular/common";
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { query } from '@angular/animations';


@Component({
  selector: 'app-collections-landing',
  standalone: false,
  templateUrl: './collections-landing.component.html',
  styleUrl: './collections-landing.component.scss'
})
export class CollectionsLandingComponent {

  action_idx: any = null;

  data: any;

  form!: FormGroup;
  downloadId: any;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedDataNotFound = false;
  isEmpty!: boolean;
  searched = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 20;
  selectedLimit: number = 10;


  errorFetchingData: boolean = false;


  @Output() onConfirmClicked = new EventEmitter();
  vehicleTypes: any[] = [];
  batchId: number;

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  clearSearchFilters() {
    this.form.reset();
    this.showSearchForm = false;
    this.data = null;
    this.count = 0;
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      payerAsin: [''],
      paymentStatus: [''],
      paymentReference: [''],
      paymentChannel: [''],
      from: [''],
      to: [''],
      revenueItem: [''],
    });

    this.batchId = this.route.snapshot.queryParams["id"];

    // if(!this.batchId){
    //   this.location.back()
    // }


    // this.search();
  }




  downloadReceipt(paymentId: any): void {
    this.downloadId = paymentId;
    let url = `/payment/download/receipt?id=` + paymentId;
    this.apiService
      .post(url, {}, { responseType: "blob" })
      .pipe(
        finalize(() => {
          this.downloadId = false;
        })
      )
      .subscribe(
        (response: Blob) => {
          const blob = new Blob([response], { type: "application/pdf" });
          const blobUrl = window.URL.createObjectURL(blob);
          const file = new Blob([response], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          downloadLink.target = "_blank";
          downloadLink.download = "receipt.pdf";
          downloadLink.click();

        },
        (error) => {
          this.openErrorModal("Error downloading receipt");
        }
      );
  }

  emailReceipt(id: number): void {
    this.router.navigate(['/admin/asset-management/market/details'], { queryParams: { id, allowEditing: true } })
  }


  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }


  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    return dialogRef
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.search();

  }

  dropdownOpen: boolean;

  attemptExport(event: MouseEvent) {
    const formValue = this.form.value;
    const from = formValue.from ? new Date(formValue.from) : null;
    const to = formValue.to ? new Date(formValue.to) : null;

    if (!from || !to) {
      this.dropdownOpen = false;

      this.openErrorModal('Date range required to export').afterClosed().subscribe(() => {
        this.showSearchForm = true;
      });
      event.stopPropagation();
      return;
    }

    const fromDate = from.toLocaleDateString();
    const toDate = to.toLocaleDateString();


    const diffInMs = to.getTime() - from.getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    if (diffInDays < 0) {
      this.dropdownOpen = false;
      event.stopPropagation();

      this.openErrorModal(
        `Invalid date range: You selected **${fromDate}** to **${toDate}**, but the end date cannot be earlier than the start date.`
      ).afterClosed().subscribe(() => {
        this.showSearchForm = true;
      });
      return;
    }

    if (diffInDays > 30) {
      this.dropdownOpen = false;

      this.openErrorModal(
        `Invalid date range: You selected **${fromDate}** to **${toDate}**, which spans more than 30 days. Please select a shorter range.`
      ).afterClosed().subscribe(() => {
        this.showSearchForm = true;
      });
      event.stopPropagation();
      return;
    }

    // Valid range
    this.showSearchForm = false;
  }


  isExportingExcel: boolean;
  isExportingPdf: boolean;
  isExportingCsv: boolean;
  exportExcel() {
    this.isExportingExcel = true;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();
    const formValues = this.form.value;

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);

    formValues.payerAsin && formData.append('payerAsin', formValues.payerAsin);
    formValues.paymentStatus && formData.append('paymentStatus', formValues.paymentStatus);
    formValues.paymentReference && formData.append('paymentReference', formValues.paymentReference);
    formValues.paymentChannel && formData.append('paymentChannel', formValues.paymentChannel);
    formValues.from && formData.append('from', formValues.from);
    formValues.to && formData.append('to', formValues.to);
    formValues.revenueItem && formData.append('revenueItem', formValues.revenueItem);

    this.apiService
      .excelPost('/collection/excel/export', formData)
      .pipe(
        finalize(() => {
          this.isExportingExcel = false;
        })
      )
      .subscribe(
        (response: Blob) => {
          const blob = new Blob([response], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const url = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = "collection_report.xlsx";
          downloadLink.click();
          downloadLink.remove();

          window.URL.revokeObjectURL(url);
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }

  exportPdf() {
    this.isExportingPdf = true;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();
    const formValues = this.form.value;

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);

    formValues.payerAsin && formData.append('payerAsin', formValues.payerAsin);
    formValues.paymentStatus && formData.append('paymentStatus', formValues.paymentStatus);
    formValues.paymentReference && formData.append('paymentReference', formValues.paymentReference);
    formValues.paymentChannel && formData.append('paymentChannel', formValues.paymentChannel);
    formValues.from && formData.append('from', formValues.from);
    formValues.to && formData.append('to', formValues.to);
    formValues.revenueItem && formData.append('revenueItem', formValues.revenueItem);

    this.apiService
      .post('/collection/pdf/export?' + new URLSearchParams(formData as any).toString(), {
        responseType: 'blob' as 'json'
      })
      .pipe(
        finalize(() => {
          this.isExportingPdf = false;
        })
      )
      .subscribe(
        (response: Blob) => {
          const blob = new Blob([response], { type: "application/pdf" });
          const blobUrl = window.URL.createObjectURL(blob);
          const file = new Blob([response], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          downloadLink.target = "_blank";
          downloadLink.download = "collection-report.pdf";
          downloadLink.click();
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }

  exportCsv() {
    this.isExportingCsv = true;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();
    const formValues = this.form.value;

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);

    formValues.payerAsin && formData.append('payerAsin', formValues.payerAsin);
    formValues.paymentStatus && formData.append('paymentStatus', formValues.paymentStatus);
    formValues.paymentReference && formData.append('paymentReference', formValues.paymentReference);
    formValues.paymentChannel && formData.append('paymentChannel', formValues.paymentChannel);
    formValues.from && formData.append('from', formValues.from);
    formValues.to && formData.append('to', formValues.to);
    formValues.revenueItem && formData.append('revenueItem', formValues.revenueItem);

    this.apiService
      .excelPost('/collection/csv/export', formData)
      .pipe(
        finalize(() => {
          this.isExportingCsv = false;
        })
      )
      .subscribe(
        (response: Blob) => {
          const blob = new Blob([response], { type: "text/csv;charset=utf-8" });


          const url = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = "collection_report.csv";
          downloadLink.click();
          downloadLink.remove();

          window.URL.revokeObjectURL(url);
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }


  search() {
    this.data = null
    this.searchedDataNotFound = false;
    this.errorFetchingData = false
    this.isSearching = true;
    this.form.markAsPristine()

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();
    const formValues = this.form.value;

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);

    formValues.payerAsin && formData.append('payerAsin', formValues.payerAsin);
    formValues.paymentStatus && formData.append('paymentStatus', formValues.paymentStatus);
    formValues.paymentReference && formData.append('paymentReference', formValues.paymentReference);
    formValues.paymentChannel && formData.append('paymentChannel', formValues.paymentChannel);
    formValues.from && formData.append('from', formValues.from);
    formValues.to && formData.append('to', formValues.to);
    formValues.revenueItem && formData.append('revenueItem', formValues.revenueItem);

    this.apiService
      .post('/collection/paged', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
        })
      )
      .subscribe(
        (response) => {

          this.count = response?.pagedResponse?.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }

          this.data = response;

        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true
        }
      );
  }

  openDialogRef(data?: any) {
    // let dialogRef = this.dialog.open(GenerateTicketModalComponent, {
    //   width: '450px',
    //   backdropClass: 'modal-form-backdrop',
    //   hasBackdrop: true,
    //   panelClass: ['modal-form'],
    //   disableClose: true,

    //   data,
    // });

    // return dialogRef;
  }



  back() {
    this.router.navigate(['/admin/asset-management'])
  }
}
